import type { TFunction } from 'i18next';

import { uniqueOptions, type FilterDef } from '@nucleus-commerce/admin-kit/index-table';
import { MemberStatus, type Member } from '@nucleus-commerce/api-client/admin';

/** Filters of the members table; `t` is the `team` namespace. Roles come from the loaded rows. */
export function memberFilters(t: TFunction, members: readonly Member[]): Array<FilterDef<Member>> {
  const roleNames = new Map(members.map((m) => [m.role.key, m.role.name]));
  return [
    {
      key: 'role',
      label: t('columns.role'),
      type: 'enum',
      pinned: true,
      getValue: (row) => row.role.key,
      options: uniqueOptions(
        members,
        (m) => m.role.key,
        (key) => roleNames.get(key) ?? key,
      ),
    },
    {
      key: 'status',
      label: t('columns.status'),
      type: 'enum',
      pinned: true,
      options: Object.values(MemberStatus).map((status) => ({
        value: status,
        label: t(`status.${status}`),
      })),
    },
  ];
}
